export default "__VITE_ASSET__CIrzZW6R__"